import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import permissionTypes from '../components/atoms/permissionsGate/permissionTypes';

export default {
  attributeName: 'tokens',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  //editURL:'key/tokens/{id}',
  getURL:'key/tokens/{id}',
 // updateURL:'key/tokens/{id}',
 // removeURL:'key/tokens/{id}',
  idAttribute:'id',
  permissionToCreate: [permissionTypes.ADMIN],
  permissionToRemove: [permissionTypes.ADMIN],
  permissionToUpdate: [permissionTypes.ADMIN],
  newButton:true,
  itemId: 'id',
  sessionParams: ['id'],
  fields: [
    {
      attributeName: 'deviceId',
      label: 'Device Id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Device Identifier',
      canOrder: true,
      canFilter: true,
    },
     {
      attributeName: 'isBlocked',
      label: 'Is device block',
      type: FormInputTypes.CHECKBOX,
      width: '6rem',
      helpText: 'Indicates if device is Blocked',
      canOrder: true,
      canFilter: false,
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expires At',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Expired date and time',
      canOrder: true,
      canFilter: true,
    },
    
    {
        attributeName: 'id',
        label: 'token',
        type: FormInputTypes.BUTTON_POPUP,
        icon: IconType.UNLOCK,
        width: '4rem',
        target:'_self',
        iconSize:'2x',
        iconColor:'#12e640',
        helpText: 'Block tokens.',
        // redirectUrl:'lives',
        actionUrl:'devices/block',
        exactWidth:'150px',
        isEditId:true,
        redirectUrl:false,
        refreshIfOk: true,
        formConfig:
        {
            title: 'Block tokens',
            description:'Block tokens',
            attributeName: 'newLiveTemplate',
            fields: [
            
            ]
        },
        visibleWhen:{ field: 'isValid', value: "bool-true" }
      },   
       {
        attributeName: 'id',
        label: 'token',
        type: FormInputTypes.BUTTON_POPUP,
        icon: IconType.LOCK,
        width: '4rem',
        target:'_self',
        iconSize:'2x',
        iconColor:'#d34e1a',
        helpText: 'Block tokens.',
        redirectUrl:false,
        refreshIfOk: true,
        actionUrl:'devices/block',
        exactWidth:'150px',
        isEditId:true,
        formConfig:
        {
            title: 'UnBlock tokens',
            description:'UnBlock tokens',
            attributeName: 'newLiveTemplate',
            fields: [
            
            ]
        },
        visibleWhen:{ field: 'isValid', value: "bool-false" }
      },   
     

  ],
};